import {connect} from 'react-redux'
import NumberEditor from './numberEditor'
import {getCurrencyPrecision} from 'selectors/settings'

const mapStateToProps = (state) => ({
  options: {
    accuracy: getCurrencyPrecision(state),
    append: state.auth.user.currencyShortDesc,
  },
})

export default connect(mapStateToProps)(NumberEditor)
